import { useSelector } from 'react-redux';
import { Constants } from '@pwc/pwc-deals-web-common';
import { selectHypothesisIfAvailable } from '../../features/hypotheses/hypothesisSlice';
import { selectAnalysesisIfAvailable } from '../../features/analyses/analysisSlice';
import { useIsPreviousVersionSelected } from './useIsPreviousVersionSelected';

type SelectRichtTextResolution = {
  richTextResolution: number | null;
  isShared: boolean;
};

export const useIsNonCommentableContent = () => {
  const isPreviousVersionSelected = useIsPreviousVersionSelected();

  const hypothesis: SelectRichtTextResolution | null = useSelector(
    selectHypothesisIfAvailable
  );
  const analyses: SelectRichtTextResolution | null = useSelector(
    selectAnalysesisIfAvailable
  );

  if (hypothesis) {
    const { isShared, richTextResolution } = hypothesis;

    return (
      !!isShared &&
      richTextResolution === Constants.RichTextResolution.NonCommentableText &&
      !isPreviousVersionSelected
    );
  }

  if (analyses) {
    const { isShared, richTextResolution } = analyses;

    return (
      !!isShared &&
      richTextResolution === Constants.RichTextResolution.NonCommentableText &&
      !isPreviousVersionSelected
    );
  }

  return false;
};
